<fin-corporate-hero
  [title]="'CORPORATE.corporatePortal.trips.title' | finLocalization"
  [description]="'CORPORATE.corporatePortal.trips.description' | finLocalization"
></fin-corporate-hero>

<div class="grey-25-bg">
  <div class="grid-col-12 grid-max-width">
    <div class="col-1-12 ps-large-y">
      <fin-trips-view></fin-trips-view>
    </div>
  </div>
</div>
